<template>
  <modal class="address-book" show-header="show-header" show-footer="show-footer" v-show="status">
    <template class="mh" slot="body">
      <span class="left serif-font title">系統繁忙中，請稍後再試</span>
    </template>

    <template slot="footer">
      <div class="text-center">
        <button class="btn btn-md ml-1 left serif-font title btn-block rounded btn-e-light-gold text-white" type="button" @click="close">確認</button>
      </div>
    </template>
  </modal>
</template>

<script>
import modal from '../modal';

const data = function() {
  return {
    status: true,
  };
};


const components = {
  modal,
};

const methods = {
  close() {
    this.status = false;
  },
};

export default {
  name: 'Modal',
  data,
  methods,
  components,
};
</script>

<style scoped>
.title {
  font-weight: 500;
}
</style>
